import { Modal, Input } from "antd";
import React, { useState, useEffect } from "react";
import { error, success } from "../../contants/snackbars";
import { addLocation, editLocation } from "../../stores/api_calls/locations";
import "./locations.scss"; // Use the same SCSS file

const LocationForm = (props) => {
  const { isEdit, data, onCancel, visible, fetchData, tablePagination } = props;
  const [submitLoading, setSubmitLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
  });

  useEffect(() => {
    if (isEdit) {
      setForm({ ...form, name: data.name });
    } else {
      setForm({ ...form, name: "" });
    }
  }, [isEdit]);

  const handleFieldChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.value,
    });
  };

  const onSubmit = () => {
    setSubmitLoading(true);
    const pagination = {
      page: tablePagination.current,
      limit: tablePagination.pageSize,
      keyword: "",
    };

    if (isEdit) {
      const updatedData = {
        id: data._id,
        name: form.name,
      };
      const location = editLocation(updatedData);

      location
        .then((res) => {
          if (res.data.success) {
            fetchData(pagination);
            success("Location Updated Successfully");
            setSubmitLoading(false);
            onClose();
          }
        })
        .catch((e) => {
          error(
            `Opps! ${e.response?.data?.server_response || "Error"} . Fetched Failed. Please try again later`,
          );
          setSubmitLoading(false);
        });
    } else {
      const newData = {
        name: form.name,
      };

      const location = addLocation(newData);

      location
        .then((res) => {
          if (res.data.success) {
            fetchData(pagination);
            success("Location Added Successfully");
            setSubmitLoading(false);
            onClose();
          }
        })
        .catch((e) => {
          error(
            `Opps! ${e.response?.data?.server_response || "Error"} . Fetched Failed. Please try again later`,
          );
          setSubmitLoading(false);
        });
    }
  };

  const onClose = () => {
    onCancel();
    setForm({ ...form, name: "" });
  };

  return (
    <div>
      <Modal
        className="formModal"
        title={`${isEdit ? "Edit" : "Add"} City`}
        visible={visible}
        onOk={onSubmit}
        okButtonProps={{ disabled: form.name !== "" ? false : true }}
        onCancel={onClose}
        okText={`${isEdit ? "Save" : "Submit"}`}
        confirmLoading={submitLoading}
      >
        <div className="form-container">
          <p className="form-label">
            City Name <span>*</span> :{" "}
          </p>
          <Input
            value={form.name}
            onChange={(text) => handleFieldChange("name", text)}
            placeholder="Please type City Name"
          />
        </div>
      </Modal>
    </div>
  );
};

export default LocationForm;
